import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router'
import { CssBaseline, ThemeProvider } from '@mui/material'

import App from './App'
import { theme } from './configuration/theme'
import ErrorBoundary from './features/error-boundary/ErrorBoundary.component'
import DocumentTitleSync from './i18n/components/DocumentTitleSync/DocumentTitleSync.component'
import IntlProvider from './i18n/components/IntlProvider/IntlProvider.component'
import { LocaleProvider } from './i18n/LocaleContext'

import './styles/fonts.css'

const container = document.getElementById('root')
if (!container) {
  throw new Error('Root element #root not found')
}

// LocaleProvider lives INSIDE BrowserRouter so it can subscribe to
// useLocation() and react to in-app navigation that flips `?lang=`. Mounting
// it outside the router would freeze the locale on the URL state at first
// paint.
ReactDOM.createRoot(container).render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <BrowserRouter>
        <LocaleProvider>
          <IntlProvider>
            <ErrorBoundary>
              {/* Inside ErrorBoundary on purpose: if DocumentTitleSync ever
                  grows a throwing path (today it only writes document.title),
                  the boundary still catches it instead of taking the whole
                  tree down. */}
              <DocumentTitleSync />
              <App />
            </ErrorBoundary>
          </IntlProvider>
        </LocaleProvider>
      </BrowserRouter>
    </ThemeProvider>
  </React.StrictMode>,
)
